<template>
  <v-toolbar dense elevation="0">
    <v-toolbar-title>
      <v-container class="text-body-1 text-sm-h5 text-md-h4 text-lg-h4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="$router.push({ name: 'Certificates' })"
              v-bind="attrs"
              v-on="on"
              small
              icon
              color="primary"
              class="mr-8"
            >
              <v-icon>fa-light fa-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>Back to list</span>
        </v-tooltip>

        <v-icon x-small color="white" class="custom-badge">fa-light fa-plus</v-icon>
        <v-icon color="primary">fa-certificate</v-icon>
        Submit certificate request
      </v-container>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: ["fileContent"],
  methods: {
    uploadFileClicked() {
      this.$emit("uploadFileClicked");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";

.custom-badge {
  position: absolute;
  margin-left: -10px;
  background-color: #81be41;
  border-radius: 50%;
  border: 2px #f6f6f6 solid;
  z-index: 999;
}
</style>
